
export const REQUEST_ADDTIMEVIDEOQUESTION= 'REQUEST_ADDTIMEVIDEOQUESTION';
export const ADDTIMEVIDEOQUESTION_RECEIVED = 'ADDTIMEVIDEOQUESTION_RECEIVED';